import React, { Fragment } from 'react';
import { Row, Col } from "react-bootstrap";
import moment from "moment";

const ItinerarioTabla = ({ data, fecha, t }) => {
  if (!data || data.length === 0) return null;
  return (
    <Col lg={4}>
      <div className="div-papw-itinerario-padd">
        <table className="papw-itinerario-table">
          <thead>
            <tr>
              <td colSpan={4}>
                <div className="row-col-titulo">
                  {t(`months.${fecha.getMonth()}`).toUpperCase()}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <div className="row-col-subtitulo">Punta Arenas - Isla Magdalena</div>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <div className="row-col-via">{t("itinerarios.salida")}</div>
              </td>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className={idx === 0 ? "papw-itinerario-table-no-top" : ""}>
                <td>{moment(item.zarpeOriginal).format("DD-MM-YYYY")}</td>
                <td>
                  {t(`days.${moment(item.zarpeOriginal).format("ddd")}`)} |{" "}
                  {moment(item.zarpeOriginal).format("HH:mm")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Col>
  );
};


export default ItinerarioTabla;